export default function TopWantedPrice({
  price,
  comparePrice,
  discount,
}) {
  return (
    <div className="flex flex-wrap items-center gap-2 sm:gap-3">
      <span className="text-lg font-black sm:text-xl md:text-2xl">
        ৳{Number(price || 0).toLocaleString()}
      </span>

      {comparePrice ? (
        <span className="text-xs text-muted-foreground line-through sm:text-sm">
          ৳{Number(comparePrice).toLocaleString()}
        </span>
      ) : null}

      {discount ? (
        <span className="rounded-full bg-red-50 px-2.5 py-1 text-[9px] font-black uppercase text-red-600">
          {discount}% Off
        </span>
      ) : null}
    </div>
  );
}
